import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import purchaseOfferDurationContent from '@components/CreditCardContent/components/purchaseOfferDurationContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'

import { ContentProps } from './Content.interface'

const getPurchaseContent = ({ creditCard }: ContentProps) => {
    return [
        guaranteedAprContent({ creditCard }),
        representativeAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        noMinimumGuaranteedCreditLimitContent({
            creditCard,
        }),
        purchaseOfferDurationContent({ creditCard }),
    ]
}

export default getPurchaseContent
